import type { Control } from "react-hook-form";
import { SavingsAmountSection } from "web_myplann/Goals/Components/AmountSections/SavingsAmountSection";
import { WithLoanAmountSection } from "web_myplann/Goals/Components/AmountSections/WithLoanAmountSection";
import type { GoalFormModel } from "web_myplann/Goals/Forms/useGoalForm";
import { GoalCategory } from "web_myplann/Goals/Types/GoalTypes";

type Props = {
	control: Control<GoalFormModel>;
	category: GoalCategory | undefined;
};

const SAVINGS_CATEGORIES: ReadonlyArray<GoalCategory> = [
	GoalCategory.Retirement,
	GoalCategory.Education,
	GoalCategory.Vacation,
];

export const GoalAmountSection = ({ control, category }: Props) => {
	if (category && SAVINGS_CATEGORIES.includes(category)) {
		return <SavingsAmountSection control={control} category={category} />;
	}

	return <WithLoanAmountSection control={control} category={category} />;
};
